import React, { useEffect, useRef, useState } from 'react'
import AllProductsStyle from '../CashPayment/AllProducts'
import Button from '../../components/Button'
import { useNavigate } from 'react-router-dom'
import api, { customFuncsApi } from '../../api'
import { get } from 'lodash'
import Layout from '../../components/Layout'
import { ErrorModal } from '../../components/Modal'
import ClipLoader from 'react-spinners/ClipLoader'
import moment from 'moment'
import { roundCurrency } from '../../utils'
import { isAxiosError } from 'axios'
import _ from 'lodash'
import { cashPayment } from '../../store/slices'
import { useDispatch, useSelector } from 'react-redux'
import customMainApi from '../../api/index'
import InventoryTransfersModal from '../../components/Modal/InventoryTansfersModal'

const AllProducts = () => {
	const {
		setClient: setClientStore,
		setImei: setImeiStore,
		setCardCode: setCardCodeStore,
	} = cashPayment.actions
	const {
		client: clientStore,
		imei: imeiStore,
		cardCode: cardCodeStore,
	} = useSelector((state) => state.cashPayment)
	const dispatch = useDispatch()

	const navigation = useNavigate()
	const errorRef = useRef()
	const infoModalRef = useRef()

	const [isLoading, setIsLoading] = useState(false)
	const [clientLoading, setClientLoading] = useState(false)
	const [warehouses, setWarehouses] = React.useState([])
	const [data, setData] = useState([])
	const [currentPage, setCurrentPage] = useState(0)
	const [clientsData, setClientsData] = useState([])
	const [userFields, setUserFields] = useState([])

	const search = () => {
		setIsLoading(true)
		customMainApi
			.get(`StockTransfers`, {
				params: {
					$skip: currentPage,
					$orderby: 'DocNum desc',

					// type: 'oneinst',
					// $skip: currentPage,
					// IntrSerial: imeiClient || undefined,
					// CardCode: client && clientCode ? clientCode : undefined,
					// itemCode: product || undefined,
				},
				headers: {
					Prefer: 'odata.maxpagesize=10',
				},
			})
			.then((res) => {
				const resData = JSON.parse(res.data)
				console.log(resData)
				setData(resData.value)
				setIsLoading(false)
			})
			.catch((err) => {
				if (isAxiosError(err)) errorRef.current?.open(get(err, 'message', ''))
				setIsLoading(false)
			})
	}

	useEffect(() => {
		userFieldsFn()
		getWarehouses()
	}, [])
	const userFieldsFn = () => {
		customMainApi
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'OITM' ",
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}

	const getWarehouses = () => {
		customMainApi
			.get('Warehouses?$select=WarehouseCode,WarehouseName')
			.then((res) => {
				console.log(res.data)
				setWarehouses(JSON.parse(res.data).value)
			})
			.catch((err) => {
				if (isAxiosError(err))
					errorRef.current?.open(
						JSON.stringify(err.response.data?.details?.message),
					)
			})
	}

	// const businessPartners = async (value) => {
	// 	setClientLoading(true)
	// 	api
	// 		.get(`BusinessPartners`, {
	// 			params: {
	// 				$select: 'CardCode, CardName, U_Telephone',
	// 				$filter: `contains(CardName, '${value}') or contains(U_Telephone, '${value}') or contains(CardCode, '${value}')`,
	// 			},
	// 			headers: {
	// 				Prefer: 'odata.maxpagesize=10',
	// 			},
	// 		})
	// 		.then((res) => {
	// 			setClientsData(JSON.parse(res.data).value || [])
	// 			setClientLoading(false)
	// 		})
	// 		.catch((err) => {
	// 			if (isAxiosError(err)) errorRef.current?.open(get(err, 'message', ''))
	// 			setIsLoading(false)
	// 		})
	// }

	const generatePDF = (docEntry, e) => {
		e.stopPropagation()
		// setIsLoading(true)
		customFuncsApi
			.get(`makeInventoryTransferPdf/${docEntry}`, {
				headers: {
					'Content-Type': 'application/pdf', // Set the correct MIME type for PDF
				},
				responseType: 'blob', // Ensure the response is treated as a blob
			})
			.then((res) => {
				const url = window.URL.createObjectURL(
					new Blob([res.data], { type: 'application/pdf' }), // Correct the blob type for PDF
				)
				const link = document.createElement('a')
				link.href = url
				link.setAttribute('download', 'InventoryTransfer.pdf') // Change file name and extension to .pdf
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
			})
			.catch((err) => {
				if (isAxiosError(err)) {
					errorRef.current?.open(
						get(JSON.parse(err.response.data), 'error.message', ''),
					)
				}
				// setIsLoading(false)
			})
	}

	useEffect(() => {
		search()
	}, [currentPage])

	const newDatas = () => {
		if (data.length >= 10) {
			setCurrentPage(currentPage + 10)
		} else {
			alert('boshqa malumot yoq')
		}
	}

	const oldData = () => {
		if (data.oldPage < 0) {
			alert('boshqa malumot yoq')
		} else {
			setCurrentPage(currentPage - 10)
		}
	}

	// const handleSearch = () => {
	// 	search()
	// }

	return (
		<Layout>
			<AllProductsStyle>
				<div className="container">
					<p className="productTitle">Перемещение запасов</p>

					<div className="flex items-center justify-end">
						<Button
							className={'btn'}
							onClick={() =>
								window.open('/create-inventory-transfers', '_blank')
							}
						>
							{'+ Добавить'}
						</Button>
					</div>

					{isLoading ? (
						<ClipLoader
							loading={true}
							size={75}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : (
						<>
							<div className="overflow-y-auto mb-8 mt-5">
								<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
									<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
										<tr>
											<th scope="col" className="px-6 py-4">
												Номер документа
											</th>
											<th scope="col" className="px-6 py-4">
												Со склада
											</th>
											<th scope="col" className="px-6 py-4">
												На склад
											</th>
											<th scope="col" className="px-6 py-4">
												дата перемещения
											</th>
											<th scope="col" className="px-6 py-4">
												Скачать PDF
											</th>
										</tr>
									</thead>
									<tbody>
										{data.map((v, i) => {
											const fromWarehouse = warehouses.find(
												(i) => i.WarehouseCode === get(v, 'FromWarehouse', '-'),
											)
											const toWarehouse = warehouses.find(
												(i) => i.WarehouseCode === get(v, 'ToWarehouse', '-'),
											)

											return (
												<tr
													key={i}
													onClick={() =>
														infoModalRef.current?.open(get(v, 'DocEntry', '-'))
													}
													className="bg-white border-b hover:bg-gray-50"
												>
													<td
														scope="row"
														className="px-6 py-4 font-medium text-gray-900"
													>
														{get(v, 'DocNum', '-')}
													</td>
													<td
														scope="row"
														className="px-6 py-4 font-medium text-gray-900"
													>
														{fromWarehouse ? fromWarehouse.WarehouseName : ''}
													</td>
													<td className="px-6 py-4">
														{toWarehouse ? toWarehouse.WarehouseName : ''}
													</td>
													<td className="px-6 py-4">
														{moment(get(v, 'DocDate', '-')).format(
															'YYYY-MM-DD',
														)}
													</td>
													<td className="px-6 py-4">
														<Button
															className={'btn'}
															onClick={(e) => {
																generatePDF(get(v, 'DocEntry', ''), e)
															}}
														>
															{'Скачать PDF'}
														</Button>
													</td>
												</tr>
											)
										})}
									</tbody>
								</table>
							</div>
							<div className="topCard">
								<div className="flex items-center gap-2 ">
									<Button
										disabled={currentPage === 0}
										className={'btn'}
										onClick={oldData}
									>
										{'<'}
									</Button>
									<p>{currentPage / 10 + 1 || 1}</p>
									<Button
										disabled={data.length < 10}
										className={'btn'}
										onClick={newDatas}
									>
										{'>'}
									</Button>
								</div>
							</div>
						</>
					)}
				</div>
			</AllProductsStyle>
			<>
				<ErrorModal
					getRef={(r) => {
						errorRef.current = r
					}}
				/>
				<InventoryTransfersModal
					getRef={(ref) => (infoModalRef.current = ref)}
					onUpdated={() => search()}
				/>
			</>
		</Layout>
	)
}

export default AllProducts
